import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Deliveries Classic Mirage Scenario
 * - `MIRAGE_SCENARIO='deliveries-classic' yarn start:mirage`
 *
 * @param {Object} server       Mirage Server
 * @param {Object} options      Options for visitors-classic scenario
 */
export default function (server, options = {}) {
  const {
    company,
    subscription: vrSubscription,
    deliveriesSubscription,
    locations,
  } = visitorsClassicScenario(server, {
    withDeliveriesSubscription: true,
    ...options,
  });

  return {
    company,
    subscriptions: [vrSubscription, deliveriesSubscription],
    locations,
  };
}
